import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/img/image.svg'
import _imports_1 from '@/img/send-button.svg'


const _hoisted_1 = {
  class: "chatContainer",
  ref: "rootElement"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-down" }),
  /*#__PURE__*/_createTextVNode(" nuovi messaggi "),
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-down" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  class: "chatWriter",
  ref: "chatWriter"
}
const _hoisted_5 = {
  key: 0,
  class: "quotedMessage"
}
const _hoisted_6 = { class: "sender" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "chatInputContainer" }
const _hoisted_9 = { class: "chatInput" }
const _hoisted_10 = { class: "chatSend" }
const _hoisted_11 = { for: "webAttachInput" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_chat_message = _resolveComponent("chat-message")!
  const _component_auto_textarea = _resolveComponent("auto-textarea")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "chatMessageContainer",
      style: _normalizeStyle(_ctx.messageContainerStyle),
      ref: "chatMessageContainer"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (item, i) => {
        return (_openBlock(), _createBlock(_component_chat_message, {
          key: i,
          onLongtouch: _ctx.onLongtouch,
          ref_for: true,
          ref: item.identifier,
          message: item
        }, null, 8, ["onLongtouch", "message"]))
      }), 128))
    ], 4),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.showNuoviMessaggi)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "newChatMessages",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToBottom && _ctx.goToBottom(...args)))
            }, _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.quotedMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "cancel",
              type: "button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancelQuote && _ctx.cancelQuote(...args)))
            }, "X"),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.quotedMessage.sender), 1),
            _createElementVNode("span", {
              class: "ellipsis",
              innerHTML: _ctx.quotedMessage.text
            }, null, 8, _hoisted_7)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("section", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_auto_textarea, {
            class: _normalizeClass(["form-control taSelect", { disabled: _ctx.chatRoom.disabled }]),
            modelValue: _ctx.messageText,
            "onUpdate:modelValue": [
              _cache[2] || (_cache[2] = ($event: any) => ((_ctx.messageText) = $event)),
              _ctx.calcMessageContainerStyle
            ],
            rows: "1",
            disabled: _ctx.chatRoom.disabled,
            onFocus: _ctx.calcMessageContainerStyle,
            placeholder: "Scrivi..."
          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "class", "onFocus"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", null, [
            _createElementVNode("input", {
              type: "file",
              id: "webAttachInput",
              style: {"display":"none"},
              onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onWebAttachChange && _ctx.onWebAttachChange(...args)))
            }, null, 32),
            _createElementVNode("label", _hoisted_11, [
              _createElementVNode("div", {
                class: _normalizeClass(["send camera pointer", {'disabled': _ctx.chatRoom.disabled}])
              }, _hoisted_13, 2)
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["send", {'disabled': !_ctx.messageText.trim() || _ctx.chatRoom.disabled }]),
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)))
          }, _hoisted_15, 2)
        ])
      ])
    ], 512)
  ], 512))
}